let counter = 0

/**
 * Unique ID generator, store counter value in _static variable_.
 * @param prefix String prefix, given empty string ID will be only numeric
 * @returns New unique ID
 */
export default (prefix = "nid") => `${prefix}${++counter}`
